import { httpClient } from '@/utils/http'
import type { UserProfile } from '@/types/api'

/**
 * 更新用户信息
 */
export class UserInfoAPI {
    static async updateUserProfile(data: any): Promise<any> {
      return httpClient.post<any>('/setUserInfo', data)
    }
  }

  export default {
    UserInfoAPI,
  }